(function () {
  var root = document.querySelector("[data-pw-about]");

  if (!root) {
    return;
  }

  function ensureMeta(attribute, key, content) {
    if (!content) {
      return;
    }

    var selector = "meta[" + attribute + "=\"" + key + "\"]";
    var tag = document.head.querySelector(selector);

    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attribute, key);
      document.head.appendChild(tag);
    }

    tag.setAttribute("content", content);
  }

  function ensureCanonical(url) {
    if (!url) {
      return;
    }

    var link = document.head.querySelector("link[rel=\"canonical\"]");

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", url);
  }

  var title = root.dataset.pwAboutSeoTitle;
  var description = root.dataset.pwAboutSeoDescription;
  var canonical = root.dataset.pwAboutCanonical;

  if (title) {
    document.title = title;
  }

  ensureMeta("name", "description", description);
  ensureCanonical(canonical);
  ensureMeta("property", "og:type", "website");
  ensureMeta("property", "og:title", title);
  ensureMeta("property", "og:description", description);
  ensureMeta("property", "og:url", canonical);
  ensureMeta("name", "twitter:card", "summary_large_image");
  ensureMeta("name", "twitter:title", title);
  ensureMeta("name", "twitter:description", description);

  var revealItems = Array.prototype.slice.call(root.querySelectorAll("[data-pw-about-reveal]"));

  if (revealItems.length === 0) {
    return;
  }

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReducedMotion) {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
    return;
  }

  root.classList.add("pw-about--js");

  revealItems.forEach(function (item, index) {
    item.style.setProperty("--pw-about-delay", Math.min((index % 5) * 55, 220) + "ms");
  });

  if (!("IntersectionObserver" in window)) {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.12
    }
  );

  revealItems.forEach(function (item) {
    observer.observe(item);
  });
})();
